import { render, staticRenderFns } from "./SchoolAssignUser.vue?vue&type=template&id=70485d02&scoped=true&"
import script from "./SchoolAssignUser.vue?vue&type=script&lang=js&"
export * from "./SchoolAssignUser.vue?vue&type=script&lang=js&"
import style0 from "./SchoolAssignUser.vue?vue&type=style&index=0&id=70485d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70485d02",
  null
  
)

export default component.exports